import { render, staticRenderFns } from "./Rc.vue?vue&type=template&id=152df86f&"
import script from "./Rc.vue?vue&type=script&lang=js&"
export * from "./Rc.vue?vue&type=script&lang=js&"
import style0 from "./Rc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports